import { LAYOUT_CONFIG } from '../config/constants';

export const textPrimary = '#5A5656';
export const textSecondary = '#707070';
export const textWhite = '#fff';
export const warningColor = LAYOUT_CONFIG.primaryColor;
